import {
    SPI,
    ActionType,
    BaseActionWidget,
    ReloadViewActionWidget,
    ViewType,
    Widget
} from '@kunlun/dependencies';
import ProductSeleectTemplateUrl from './productSeleectTemplateUrl.vue'

@SPI.ClassFactory(
  BaseActionWidget.Token({
    viewType: ViewType.Table,
    actionType: ActionType.Client,
    name: '$$internal_ReloadData',
    model: 'deli.aries.product.selection.TaskStrategyDetail',
    widget: 'ClientAction'
  })
)
export class productSeleectTemplateUrl extends ReloadViewActionWidget {
  initialize(props: any) {
    super.initialize(props);
    this.setComponent(ProductSeleectTemplateUrl);
    return this;
  }
}
